import { useAccountingStore } from '@/stores/accounting';
import ROUTES from '@/utils/constants/accounting_routes_constants';
import USER_PERMISSIONS from '@/utils/constants/accounting_permissions_constants';

const actions = [
    {
        routeName: ROUTES.ACCT_SETTINGS_CHART.name,
        items: [
            {
                title: 'add new account',
                routeName: ROUTES.ACCT_SETTINGS_CHART_ADD_NEW.name,
                allowed: () => {
                    const acctStore = useAccountingStore();
                    return acctStore.hasPermission(USER_PERMISSIONS.ACCT_ADD_GL_ACCOUNT);
                },
            },
        ],
    },
];

export default actions;
